import React from 'react';

import { INTERNAL_LINKS, STATUS_LIST } from '../../../enum';
import { momentFormat } from '../../../utils/common';
import ProfileNamePicture from '../../shared-ui/ProfileNamePicture';
import StatusTag from '../../Tag/StatusTag';
import CustomTable from '..';

const CompanyUsersFavrValuesSysAdminTable = props => {
  const { t, dataSource, ...rest } = props;

  const COLUMNS = [
    {
      width: 200,
      defaultSortOrder: 'ascend',
      title: t('name'),
      key: ['firstName', 'lastName'].join(','),
      render: (actions, data) => (
        <ProfileNamePicture
          t={t}
          showStatus={false}
          user={data}
          redirectTo={`${INTERNAL_LINKS.USER_DETAILS_PROFILE(data._id)}`}
        />
      ),
      sorter: true,
    },
    {
      width: 200,
      ellipsis: true,
      key: 'email',
      dataIndex: 'email',
      title: t('Email'),
      render: email => email || '-',
      sorter: true,
    },
    {
      width: 100,
      key: 'status',
      dataIndex: 'status',
      title: t('Status'),
      render: status => <StatusTag status={status} />,
      sorter: true,
    },
    {
      align: 'center',
      width: 150,
      title: t('favrRateRefreshStatus'),
      key: 'rateRefreshSuccess',
      dataIndex: 'rateRefreshSuccess',
      sorter: true,
      render: isSuccess => (
        <StatusTag
          status={isSuccess ? STATUS_LIST().Status.SUCCESS : STATUS_LIST().Status.FAILED}
        />
      ),
    },
    {
      width: 130,
      title: t('dateLastSuccessfulRateRefresh'),
      key: 'lastSuccessfulRefreshDate',
      dataIndex: ['lastSuccessfulRefreshDate'],
      render: created => (created ? momentFormat(created, 'MMMM DD, YYYY') : '-'),
      sorter: true,
    },
    {
      width: 120,
      title: t('lastKnownGoodZipCode'),
      key: 'previousZipCode',
      dataIndex: 'previousZipCode',
      render: zipCode => zipCode || '-',
      sorter: true,
    },
    {
      width: 120,
      title: t('currentHomeAddressZipCode'),
      key: 'personalInfor.homeAddress.postalCode',
      dataIndex: ['personalInfor', 'homeAddress', 'postalCode'],
      render: zipCode => zipCode || '-',
      sorter: true,
    },
  ];

  return (
    <CustomTable
      {...rest}
      scroll={{ x: 1400 }}
      showSearchInput={false}
      columns={COLUMNS}
      dataSource={dataSource}
    />
  );
};

export default CompanyUsersFavrValuesSysAdminTable;
